const SAVED_STATUS = {
  SAVED: 'SAVED',
  REMOVED: 'REMOVED',
  ERROR: 'ERROR',
  RESET: 'RESET',
};

export { SAVED_STATUS };
